module.exports = __webpack_public_path__ + "img/certificate-1.1d0d71fa.jpg";